// 기록 화면처럼 여러 기록이 함께 펼쳐지는 곳에서 기록마다 근거 보기 데이터를 불러와 위로 올려 준다.
import { useEffect } from 'react';
import useSaenggibuEvidence from './useSaenggibuEvidence';

export default function SaenggibuEvidenceLoader({ recordId, entries, enabled = true, onChange }) {
  const api = useSaenggibuEvidence({ recordId, entries, enabled });
  const { get, statusOf } = api;
  useEffect(() => {
    onChange?.(recordId, { get, statusOf });
  }, [recordId, get, statusOf, onChange]);
  useEffect(() => () => onChange?.(recordId, null), [recordId, onChange]);
  return null;
}
